import { api } from "./api";
import { endpoints } from "./endpoints";

export const getPaymentPlansApi = async (payload: {
  teamSchema: string;
  totalAmount: number;
}) => {
  return await api.post(endpoints.getPaymentPlans, payload);
};
